import React, { useState, useRef } from 'react';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Form, Input, Row, Space, message, Switch  } from 'antd';
import {insert, update, getById} from '../../../../../apis/NivelesOrganizacionalesNivel4Api';
import './Edit.scss';

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 4,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 20,
        },
    },
};
const formItemLayoutWithOutLabel = {
wrapperCol: {
    xs: {
    span: 24,
    offset: 0,
    },
    sm: {
    span: 20,
    offset: 4,
    },
},
};

const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [disabled, setDisabled] = useState(false);
    
        const handleOk = async () => {
        try {
            const fields = await form.validateFields();
            let success = false;
            if (ID > 0) {
                //Update
                const payload = {
                    id: ID,
                    activo: true,
                    ...fields,
                }
                const response = await update(payload);
                success = response.ok;
                if (response.ok) {
                    message.success('Se actualizó correctamente la definición!');
                }
            } else {
                //Create
                const payload = {
                    id: ID,
                    activo: true,
                    ...fields,
                }
                const response = await insert(payload);
                success = response.ok;
                if (response.ok) {
                    setID(response.payload);
                    message.success('Se guardo correctamente la definición!');
                }
            }

            if (success) {
                finish(true, true);
            }
        } catch (errorInfo) {
            message.error('Por favor completa todos los campos obligatorios.');
        }
        //const fields = form.getFieldsValue();

    }

    const onClose = ()=>{
        setShowModal(false);
        finish(false);
        setInitialValues(null);
    }

    const effectRan = useRef(false);
    React.useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          if(ID > 0){
            refreshData();
          }else{
            setInitialValues({
              descripcion: '',
              clave: '',
              activo: true,
            });
          }
        })();
      }
      return () => effectRan.current = true;
    }, [ID]);

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let item = response.payload;
            setInitialValues(item);
        }
    }

    return (
      <Drawer
        title={<>
          { ID > 0 ? '(' + ID + ') ': ''} 
          {title}
        </>}
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        height={'100%'}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
          <Space>
            <Button onClick={onClose}>Cancelar</Button>
            <Button onClick={handleOk} type="primary">
            Guardar
            </Button>
          </Space>
        ]}
      >
        {
            initialValues && 
            <Form layout="vertical" disabled={disabled}
            form={form} requiredMark initialValues={initialValues} onFinish={handleOk} >
                <Row gutter={16}>
                    <Col md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                        <Form.Item
                            name="clave"
                            label="Clave"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega la clave',
                            },
                            ]}>
                            <Input placeholder="Por favor agrega la clave" style={{width: '80%',}}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                        <Form.Item
                            name="descripcion"
                            label="Descripcion"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega una descripion',
                            },
                            ]}>
                            <Input placeholder="Por favor agrega una descripion" style={{width: '80%',}}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="activo"
                            label="Activo"
                            >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        }
    </Drawer>
  );
};
export default App;